videojs.addLanguage('gl', {
  "Audio Player": "Reprodutor de son",
  "Video Player": "Reprodutor de vídeo",
  "Play": "Reproducir",
  "Pause": "Pausa",
  "Replay": "Repetir",
  "Current Time": "Tempo reproducido",
  "Duration": "Duración",
  "Remaining Time": "Tempo restante",
  "Stream Type": "Tipo de fluxo",
  "LIVE": "EN DIRECTO",
  "Seek to live, currently behind live": "Buscando directo, actualmente tras en directo",
  "Seek to live, currently playing live": "Buscando directo, actualmente reproducindo en directo",
  "Loaded": "Cargado",
  "Progress": "Progresión",
  "Progress Bar": "Barra de progreso",
  "progress bar timing: currentTime={1} duration={2}": "{1} de {2}",
  "Fullscreen": "Pantalla completa",
  "Non-Fullscreen": "Xanela",
  "Mute": "Silenciar",
  "Unmute": "Son activado",
  "Playback Rate": "Velocidade de reprodución",
  "Subtitles": "Subtítulos",
  "subtitles off": "subtítulos desactivados",
  "Captions": "Subtítulos para xordos",
  "captions off": "subtítulos para xordos desactivados",
  "Chapters": "Capítulos",
  "Descriptions": "Descricións",
  "descriptions off": "descricións desactivadas",
  "Audio Track": "Pista de son",
  "Volume Level": "Nivel do volume",
  "You aborted the media playback": "Vostede interrompeu a reprodución do medio.",
  "A network error caused the media download to fail part-way.": "Un erro de rede interrompeu a descarga do medio.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Non foi posíbel cargar o medio por mor dun fallo de rede ou do servidor ou porque o formato non é compatíbel.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Interrompeuse a reprodución do medio por mor dun problema de estragamento dos datos ou porque o medio precisa funcións que o seu navegador non ofrece.",
  "No compatible source was found for this media.": "Non se atopou ningunha orixe compatíbel con este vídeo.",
  "The media is encrypted and we do not have the keys to decrypt it.": "O medio está cifrado e non temos as chaves para descifralo .",
  "Play Video": "Reproducir vídeo",
  "Close": "Pechar",
  "Close Modal Dialog": "Pechar a caixa de diálogo modal",
  "Modal Window": "Xanela modal",
  "This is a modal window": "Esta é unha xanela modal",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Este diálogo modal pódese pechar premendo a tecla Escape ou activando o botón de pechar.",
  ", opens captions settings dialog": ", abre o diálogo de axustes dos subtítulos para xordos",
  ", opens subtitles settings dialog": ", abre o diálogo de axustes dos subtítulos",
  ", opens descriptions settings dialog": ", abre o diálogo de axustes das descricións",
  ", selected": ", séleccionado",
  "captions settings": "axustes dos subtítulos para xordos",
  "subtitles settings": "axustes dos subtítulos",
  "descriptions settings": "axustes das descricións",
  "Text": "Texto",
  "White": "Branco",
  "Black": "Negro",
  "Red": "Vermello",
  "Green": "Verde",
  "Blue": "Azul",
  "Yellow": "Marelo",
  "Magenta": "Maxenta",
  "Cyan": "Cian",
  "Background": "Fondo",
  "Window": "Xanela",
  "Transparent": "Transparente",
  "Semi-Transparent": "Semi-transparente",
  "Opaque": "Opaca",
  "Font Size": "Tamaño das letras",
  "Text Edge Style": "Estilo do bordos do texto",
  "None": "Ningún",
  "Raised": "Érguida",
  "Depressed": "Caída",
  "Uniform": "Uniforme",
  "Dropshadow": "Sombra caída",
  "Font Family": "Familia de letras",
  "Proportional Sans-Serif": "Sans-Serif proporcional",
  "Monospace Sans-Serif": "Sans-Serif monoespazo (caixa fixa)",
  "Proportional Serif": "Serif proporcional",
  "Monospace Serif": "Serif monoespazo (caixa fixa)",
  "Casual": "Manuscrito",
  "Script": "Itálica",
  "Small Caps": "Pequenas maiúsculas",
  "Reset": "Reiniciar",
  "restore all settings to the default values": "restaurar todos os axustes aos valores predeterminados",
  "Done": "Feito",
  "Caption Settings Dialog": "Diálogo de axustes dos subtítulos para xordos",
  "Beginning of dialog window. Escape will cancel and close the window.": "Inicio da xanela de diálogo. A tecla Escape cancelará e pechará a xanela.",
  "End of dialog window.": "Fin da xanela de diálogo.",
  "{1} is loading.": "{1} está a cargar."
});